export default "__VITE_ASSET__GiiHvNS___"